Vue.component("anchorsection", {
  props: ["postData", "idx"],
  template: "#home-anchor-template"
});
if ($("#vue-homeanchor").length) {
  new Vue({
    el: "#vue-homeanchor",
    data: {
      posts: [],
      loading: false,
      className: null,
      sectionName: null,
      termUrl: null
    },
    beforeMount: function () {
      this.className = this.$el.attributes["data-match-class"].value;
      this.sectionName = this.$el.attributes["data-match-name"].value;
      this.termUrl = this.$el.attributes["data-match-url"].value;
    },
    updated: function () {
      var sEpicaAnchors = document.querySelectorAll('#vue-homeanchor[data-epica-module-name] a[href]');
      sEpicaAnchors.forEach(function (el) {
        el.addEventListener('click', epicaClick);
      });
      lazyImagesInit();
      textFillResize();
    },
    mounted: function () {
      var sEpicaAnchors = document.querySelectorAll('#vue-homeanchor[data-epica-module-name] a[href]');
      sEpicaAnchors.forEach(function (el) {
        el.addEventListener('click', epicaClick);
      });
      textFillResize();
    },
    methods: {
      getPosts: function (name) {
        loading = true;
        this.$http.get("/api/anchor/" + name).then(
          function (response) {
            this.posts = response.body;
            this.className = this.posts[0].section.className;
            this.sectionName = this.posts[0].section.name;
            this.termUrl = this.posts[0].section.termUrl;
            loading = false;
          },
          function (response) { }
        );
      }
    }
  });
}
